module.exports = __webpack_public_path__ + "static/media/defaultExerciseThumbnail.da8d63cf.svg";